export const SYNC_HTTP_METHODS = [
  {
    label: 'GET',
    value: 'GET'
  },
  {
    label: 'POST',
    value: 'POST'
  }
];
